import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

import {
  useInviteNonUserMutation,
  InviteNonUser_Input
} from 'generated/graphql';

export type IFormState = {
  email: string;
  firstName: string;
  lastName: string;
  projectId: string;
  roleId: string;
};

const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  projectId: '',
  roleId: ''
};

export function useFormState(projectId: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      email: {
        label: 'Email',
        type: 'text'
      },
      firstName: {
        label: 'First Name',
        type: 'text'
      },
      lastName: {
        label: 'Last Name',
        type: 'text'
      },
      projectId: {
        label: 'Project id',
        type: 'text'
      },
      roleId: {
        label: 'Project Role',
        type: 'text'
      }
    }
  });

  useEffect(() => {
    if (formState.projectId === '' && projectId !== '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'projectId',
          value: projectId
        }
      });
    }
    () => {};
  }, [
    dispatch,
    formState.projectId,
    projectId
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useInviteNonUser() {
  const [
    fnMutate,
    tuple
  ] = useInviteNonUserMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: InviteNonUser_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
